import React from "react";
import BusinessDeactivation from "../../sections/BusinessDashboard/Dashboard/BusinessDeactivation";
import DashboardMainContainer from "../../components/common/Containers/DashboardMainContainer";
import { AdminPageTitle } from "../../sections/AdminDashboard/shared/adminUx";
import { BUSINESS_CENTERED_PAGE_TITLE_CLASS } from "../../sections/BusinessDashboard/shared/businessLayoutSpec";

const Deactivation = () => {
  return (
    <DashboardMainContainer className="!bg-white">
      <AdminPageTitle className={`text-offblack ${BUSINESS_CENTERED_PAGE_TITLE_CLASS}`}>
        Deactivate your business account
      </AdminPageTitle>
      <div className="flex justify-center min-h-screen">
        <BusinessDeactivation />
      </div>
    </DashboardMainContainer>
  );
};

export default Deactivation;
